module.exports = __webpack_public_path__ + "static/media/edith.a30ad8d4.png";